import React from "react";
import { FaChevronDown } from "react-icons/fa6";
import video1 from "../assets/glowin-video.mp4";

const SubHeader: React.FC = () => {
  return (
    <section className="relative h-screen flex items-center justify-center text-white">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover opacity-65"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={video1} type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>

      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50"></div>

      <div className="relative z-10 text-center px-4 mt-[-100px]">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          Soluciones de Limpieza Automotriz a Domicilio
        </h1>
        <p className="text-lg md:text-2xl max-w-2xl mx-auto">
          En Glowin, transformamos la limpieza automotriz con servicios que garantizan la
          calidad y la eficiencia directamente en la comodidad de tu hogar.
        </p>
        
        <p className="text-3xl font-caveat animate-bounce relative top-20">
          · SOMOS AUTOSUSTENTABLES ·
        </p>

        <div className="flex justify-center relative" style={{ transform: "translateY(80px)" }}>
  <p className="text-white text-5xl">
    <FaChevronDown />
  </p>
</div>

      </div>
    </section>
  );
};

export default SubHeader;

